import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { GroupedByBrandShelfTalkerCardData } from '../../../../../../../models/shelf-talkers/grouped-by-brand-shelf-talker-card-data';
import { GlassHouseFiveBySevenBackgroundViewModel } from './glass-house-five-by-seven-background-view-model';

@Component({
  selector: 'app-glass-house-five-by-seven-background',
  templateUrl: './glass-house-five-by-seven-background.component.html',
  styleUrl: './glass-house-five-by-seven-background.component.scss',
  providers: [GlassHouseFiveBySevenBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseFiveBySevenBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: GlassHouseFiveBySevenBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GroupedByBrandShelfTalkerCardData;
}
